// extracted by mini-css-extract-plugin
module.exports = {"tableCell":"TableCell_tableCell__EKP3R"};